import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingModal from '@ublique/components/LoadingModal'
import TextInput from '@ublique/components/TextInput'
import './index.scss'
import { isEmpty } from 'lodash'

const CreateNewInstanceModal = ({ open, close, data }) => {
  const { t } = useTranslation('Shell', 'Common')
  const { instances, onSubmit } = data
  const [isInvalidName, setIsInvalidName] = useState(false)
  const [instanceName, setInstanceName] = useState('')

  const isInvalid = (value) => {
    const pattern = /[!"£$%//()=?^|]/
    const titlesAlreadyUsed = instances.map((i) => i.title)
    return (
      isEmpty(value) || pattern.test(value) || titlesAlreadyUsed.includes(value)
    )
  }

  const onChange = ({ target: { value } }) => {
    setInstanceName(value)
    setIsInvalidName(isInvalid(value))
  }

  const onRequestSubmit = async () => {
    if (isInvalid(instanceName)) {
      setIsInvalidName(isInvalid(instanceName))
      return
    }
    onSubmit(instanceName)
    close()
  }

  return (
    <LoadingModal
      open={open}
      preventCloseOnClickOutside
      className='create-new-instance-modal'
      modalHeading={t(`NewInstance.CreateNewInstance`)}
      primaryButtonText={t('NewInstance.Create')}
      secondaryButtonText={t('Common:Cancel')}
      iconDescription={t('Common:Close')}
      onRequestSubmit={onRequestSubmit}
      primaryButtonDisabled={isInvalidName}
      onRequestClose={close}
      onSecondarySubmit={close}
    >
      <TextInput
        id='instanceName'
        labelText={t('NewInstance.FieldName')}
        placeholder={t('NewInstance.FieldNamePlaceholder')}
        invalidText={t('NewInstance.FieldNameInvalid')}
        invalid={isInvalidName}
        onChange={onChange}
        autoComplete='off'
      />
    </LoadingModal>
  )
}

export default CreateNewInstanceModal
